module.exports = __webpack_public_path__ + "static/media/navigation_flow.6786a8f1.jpg";